module.exports = __webpack_public_path__ + "static/Shambling_Mound-ce9329ad0a9df0112ac807faabf044d4.jpg";